/**
 * Die Hoehenordnung des Bretts.
 *
 * Jede Flaeche hat genau eine y-Hoehe, und zwischen zwei Flaechen liegen mindestens
 * zwei Zehntelmillimeter. Das ist keine Kosmetik: bei einer Kamera mit `near = 40`
 * und einem Brett von 720 mm loest der Tiefenpuffer in etwa 0,002 mm auf. Wer Ebenen
 * enger stapelt, bekommt genau das Treppenmuster, das im ersten Belegbild ueber den
 * aufgedruckten Grundrissen lag.
 */

export const EBENE = {
  /** Oberseite des Brettkoerpers. */
  brett: 0,
  /** Fahrbahn. */
  strasse: 0.6,
  /** Trennstriche zwischen den Feldern. */
  trenner: 1.0,
  /** Bank- und Rathauslinie. */
  linie: 1.2,
  /** Feldsymbole. */
  symbol: 1.4,
  /** Autos stehen auf der Fahrbahn. */
  auto: 1.6,
  /** Oberkante eines Hotelgelaendes. */
  gelaende: 2.0,
  /** Gehwege beidseits der Fahrbahn. */
  gehweg: 2.2,
  /** Aufgedruckter Grundriss eines Bauplatzes. */
  grundriss: 2.4,
  /** Innenflaeche des aufgedruckten Grundrisses. */
  grundrissInnen: 2.6,
  /** Hoteleingaenge stehen auf dem Gelaende. */
  eingang: 2.8,
  /** Beschriftungen. */
  schrift: 3.0,
} as const

/**
 * Wie tief ein Gebaeude in das Gelaende eingelassen wird.
 *
 * Ein Gebaeude beginnt nicht auf der Gelaendeoberkante, sondern darunter. Damit gibt
 * es weder eine Fuge noch zwei Flaechen auf gleicher Hoehe - egal, aus welchem Winkel
 * oder mit welcher Zoomstufe man hinsieht. Sichtbar ist die Kante trotzdem genau an
 * der Gelaendeoberkante, weil das Gelaende davor liegt.
 */
export const EINLASS = 0.9

/** y-Wert, an dem die Unterkante eines Gebaeudes liegt. */
export const GEBAEUDE_UNTERKANTE = EBENE.gelaende - EINLASS
